module.exports = __webpack_public_path__ + "static/img/icon_line@2x.ff61c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/contactInfo/icon_line@2x.png
// module id = JV9K
// module chunks = 0